
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...pathListaSeo]",
      function () {
        return require("private-next-pages/[...pathListaSeo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...pathListaSeo]"])
      });
    }
  